<div class="evs-modal">

  <div class="evs-icon">
    <i class="fa-solid fa-triangle-exclamation"></i>
  </div>

  <div class="evs-title" translate>Quitter le test ?</div>

  <div class="evs-desc" translate>
    Si tu quittes le test de positionnement, toutes tes réponses seront perdues et tu devras recommencer depuis le début.
  </div>

  <div class="evs-actions">
    <button class="evs-btn-primary" (click)="close()" translate>
      Reprendre le test
    </button>
    <button class="evs-btn-link" (click)="quit()" translate>
      Quitter le test
    </button>
  </div>

</div>
